import { Avatar, AvatarGroup, Box, Typography } from '@mui/material'
import EntityAvatar from 'theme/components/Avatar/EntityAvatar'

export const renderTeamOption = (props: any, option: any, { selected }: { selected?: boolean } = {}, theme: any) => {
  const { key, id, ...rest } = props
  const userName = option.name || option.Name || `${option?.first_name || ''} ${option?.last_name || ''}`.trim()
  return (
    <Box
      key={`${key}-${id}`}
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}
      {...rest}
    >
      {option.image_512 || option.img_link || option.image_48 ? (
        <EntityAvatar name={userName} photoUrl={option?.image_512 || option.img_link || option.image_48} size="sm" showName={false} style={{ marginRight: 8 }} />
      ) : (
        <Avatar style={{ marginRight: 8 }} />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          {userName}
        </Typography>
        {option?.role && (
          <Typography
            sx={{
              color: theme.palette.text.success,
              fontSize: '13px',
              fontStyle: 'italic',
              fontWeight: 'bold',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.role}`}</Typography>
        )}
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: '11px',
            fontStyle: 'italic',
            textAlign: 'left',
            width: '100%',
          }}
        >
          {option.email || option.Email || ''}
        </Typography>

        {option?.title && (
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontSize: '11px',
              fontStyle: 'italic',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.title}`}</Typography>
        )}
      </Box>
    </Box>
  )
}

export const renderUserOption = (props: any, option: any, { selected }: { selected?: boolean } = {}, theme: any) => {
  const { key, id, ...rest } = props
  const userName = option.name || option.Name || `${option?.first_name || ''} ${option?.last_name || ''}`.trim()
  return (
    <Box
      key={`${key}-${id}`}
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}
      {...rest}
    >
      {option.image_512 || option.image_48 || option.img_link ? (
        <EntityAvatar name={userName} photoUrl={option.image_512 || option.img_link || option.image_48} size="sm" showName={false} style={{ marginRight: 8 }} />
      ) : (
        <Avatar style={{ marginRight: 8 }} />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          {userName}
        </Typography>
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: '11px',
            fontStyle: 'italic',
            textAlign: 'left',
            width: '100%',
          }}
        >
          {option.email || option.Email || ''}
        </Typography>
        {option?.panda_contact_id && (
          <Typography
            sx={{
              color: theme.palette.text.success,
              fontSize: '11px',
              fontStyle: 'italic',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.panda_contact_id}`}</Typography>
        )}
        {option?.id && (
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontSize: '11px',
              fontStyle: 'italic',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.id}`}</Typography>
        )}
      </Box>
    </Box>
  )
}

export const renderUserTags = value => {
  return (
    <AvatarGroup max={2} spacing="small">
      {value.map(
        option =>
          option &&
          (option.img_link || option.image_48 ? (
            <EntityAvatar
              name={option.name || ''}
              photoUrl={option.img_link || option.image_48}
              size="sm"
              showName={false}
              key={option.gusers_uuid || option.id || option.user_uuid}
            />
          ) : (
            <Avatar key={option.gusers_uuid || option.id || option.user_uuid} />
          ))
      )}
    </AvatarGroup>
  )
}
